import styled from 'styled-components';

export const SocialStyledContainer = styled.div`
  max-width: 280px;
  flex: 1;
  & .title {
    margin-bottom: 16px;
  }
`;
export const SocialLink = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
